// api/axios.js
import axios from 'axios';
import { toast } from 'react-toastify';
import store from '../redux/store';
import { clearSyncTimestamp } from '../helper/utilsFunctions';
import { getRouterInstance } from '../routerInstance';

// import store from '../redux/store';

export const apiUrl = process.env.REACT_APP_BACKEND_API_URL;
// export const apiUrl = 'https://b99d-102-88-113-219.ngrok-free.app';
// export const apiUrl = 'http://192.168.125.126:4000'
// export const apiUrl = 'https://bdsocials-production.up.railway.app';  //local server

const apiInstance = axios.create({
    baseURL: apiUrl,
    withCredentials: true,
});

apiInstance.interceptors.response.use (
    (response) => response,
    (error) => {
        // console.log('error dat; ', error.response)
        if (error.response?.status === 401 && error.response?.data?.message !== "Incorrect password") {
           
            if (store.getState().user.userData?.userId) {
                toast.info("Session expired! You have been logged out. Please log in again.");
                store.dispatch({ type: 'RESET_STORE' })
                clearSyncTimestamp()
                const router = getRouterInstance();
                const { pathname, search } = window.location;
                if (router && !pathname.startsWith("/login")) {
                    const next = pathname === "/" ? "" : `?next=${encodeURIComponent(pathname + search)}`;
                    router.navigate(`/login${next}`, { replace: true });
                }
            } else {
                clearSyncTimestamp()
            }

            return Promise.reject(error)
        }

        const backendMessage =
            error.response?.data?.message ||
            error.response?.data?.error || 
            error.message;
        
        return Promise.reject(new Error(backendMessage));
    }
);

export default apiInstance;
